export class GetTableDataQualityColumnInspectResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "column",
            "baseName": "column",
            "type": "ColumnNullRate",
            "format": ""
        },
        {
            "name": "trend",
            "baseName": "trend",
            "type": "MetricTimeseries",
            "format": ""
        },
        {
            "name": "sampledRows24h",
            "baseName": "sampledRows24h",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetTableDataQualityColumnInspectResponse.attributeTypeMap;
    }
    constructor() {
    }
}
